import { useEffect, useState } from "react";
import { adminApi, extractApiError } from "../../lib/adminApi";
import {
    AdminPageHeader,
    SectionCard,
    FormActions,
} from "../../components/admin/FormPrimitives";
import { ImageUploadPicker } from "../../components/admin/ImageUploadPicker";

export default function AdminImages() {
    const [data, setData] = useState(null);
    const [state, setState] = useState({ status: "idle", error: "" });

    useEffect(() => {
        (async () => {
            try {
                const { data: doc } = await adminApi.get(
                    "/admin/site-content/images",
                );
                setData(doc.data || { logo_url: "", portrait_url: "" });
            } catch {
                setData({ logo_url: "", portrait_url: "" });
            }
        })();
    }, []);

    const onSubmit = async (e) => {
        e.preventDefault();
        setState({ status: "submitting", error: "" });
        try {
            await adminApi.put("/admin/site-content/images", { data });
            setState({ status: "success", error: "" });
            setTimeout(
                () =>
                    setState((s) =>
                        s.status === "success"
                            ? { status: "idle", error: "" }
                            : s,
                    ),
                2500,
            );
        } catch (err) {
            setState({ status: "error", error: extractApiError(err) });
        }
    };

    return (
        <div data-testid="admin-images-page">
            <AdminPageHeader
                title="Images du site"
                subtitle="Téléversez le logo du cabinet et la photo professionnelle. Elles remplaceront instantanément les placeholders du site public."
            />
            {data === null ? (
                <SectionCard title="Chargement…">…</SectionCard>
            ) : (
                <SectionCard title="Assets visuels" testId="images-card">
                    <form onSubmit={onSubmit}>
                        <ImageUploadPicker
                            label="Logo — Header et Footer"
                            hint="Format paysage (le monogramme MABS sur fond noir). Sera affiché dans l'en-tête, le pied de page et l'espace admin."
                            value={data.logo_url}
                            onChange={(url) =>
                                setData({ ...data, logo_url: url })
                            }
                            testId="images-logo"
                        />
                        <ImageUploadPicker
                            label="Photo — Portrait de Maître Sanou"
                            hint="Format portrait, fond neutre. Utilisée dans le hero de l'accueil et sur la page 'À propos'."
                            value={data.portrait_url}
                            onChange={(url) =>
                                setData({ ...data, portrait_url: url })
                            }
                            testId="images-portrait"
                        />
                        <FormActions
                            saving={state.status === "submitting"}
                            status={state.status}
                            error={state.error}
                            testId="images-form"
                        />
                    </form>
                </SectionCard>
            )}
        </div>
    );
}
